<template>
  <div style="user-select: none; -ms-user-select: none; -moz-user-select: none; -webkit-user-select: none;">
    <h3 style="user-select: none; -ms-user-select: none; -moz-user-select: none; -webkit-user-select: none;">Signature</h3>
    <p style="user-select: none; -ms-user-select: none; -moz-user-select: none; -webkit-user-select: none;">We need your digital signature to process the application. Please sign in the box below using your mouse cursor or finger.</p>
    <VueSignaturePad  height="120px" ref="signaturePad" style="box-shadow: 1px 3px 6px rgba(50, 114, 220, 0.1), 0 1px 3px rgba(0,0,0,0.1); margin-bottom: 20px; background: ivory; user-select: none;" />
    <div class="buttons is-right">
      <a class="button is-link is-inverted padded-button next-button" @click="clear">Clear</a>
      <a class="button is-link padded-button next-button" @click="next">Save</a>
    </div>
  </div>
</template>

<script>
import Input from '@/components/shared/Input'
import VueSignaturePad from 'vue-signature-pad'
export default {
  name: 'Signature',
  components: {
    VueSignaturePad
  },
  data () {
    return {
      obj: 'pg',
      inputs: {
        signature: ''
      }
    }
  },
  methods: {
    clear () {
      this.$refs.signaturePad.clearSignature()
    },
    next () {
      const { isEmpty, data } = this.$refs.signaturePad.saveSignature()
      console.log(this.$refs.signaturePad.saveSignature())
      const sig = data
      if (isEmpty) {
        console.log(isEmpty)
        alert('Please provide a valid signature.')
      } else {
        console.log('SIGNATURE', sig)
        this.inputs.signature = sig
        this.$emit('next', this.$data)
        console.log(this.$data)
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
